module.exports = __webpack_public_path__ + "static/media/lock.f0d99019.svg";